import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

// Generated by i18n-cache-busting.js
import * as cacheBusting from '../../i18n-cache-hash.json';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    const hash = (cacheBusting as any)[lang] || '';
    const path = `/i18n/${lang}.json${hash ? '?v=' + hash : ''}`;
    return this.http.get(path);
  }
}
